import type { RenderField } from '~/types/applicationForm'

function SupportedFileTypes({ field }: { field: RenderField }) {
  if (!field.type.customData?.supportedFileTypes) {
    return <>{''}</>
  }

  return (
    <>
      {`${field.type.customData.supportedFileTypes.join(', ').toUpperCase()}`}
    </>
  )
}

function UploadSizeLimit({ field }: { field: RenderField }) {
  if (!field.type.customData?.maxFileSize) {
    return <>{''}</>
  }

  return (
    <>
      {`up to ${Math.round(field.type.customData.maxFileSize / 1024 / 1024)}MB`}
    </>
  )
}

export function UploadInput({
  field,
  name,
  errors,
}: {
  field: RenderField
  name: string
  errors?: string[]
}) {
  return (
    <div className="mt-8">
      <label className="block text-sm font-medium text-gray-700">
        {field.label}
        {field.isRequired && <span className="text-rose-500"> *</span>}
      </label>
      <p className="mt-1 text-xs text-gray-500">
        <SupportedFileTypes field={field} /> <UploadSizeLimit field={field} />
      </p>
      <div className="mt-2">
        <label className="block">
          <span className="sr-only">Choose profile photo</span>
          <input
            type="file"
            name={name}
            className="block w-full text-sm text-slate-500 file:mr-4 file:cursor-pointer file:rounded-md file:border-0 file:bg-gray-50 file:py-2 file:px-4 file:text-sm file:font-semibold file:text-accent-color hover:file:bg-gray-100"
          />
        </label>
      </div>
      {errors && (
        <div className="pt-1 text-red-700" id="password-error">
          {errors[errors.length - 1]}
        </div>
      )}
    </div>
  )
}
